module.exports = __webpack_public_path__ + "img/right.3f52d423.svg";